import { useContext } from 'react';
import { ScrollContext } from './ScrollContext';

export const useIsInScrollView = () => {
    const { isInScroll } = useContext(ScrollContext);
    return isInScroll;
};

export const useScrollRef = () => {
    const { scrollRef } = useContext(ScrollContext);
    return scrollRef;
};
